import { ApiClient, ApiError } from "./ApiClient";
import { ClientApi } from "./ClientApi";
import { ImportPayloadRow } from "@utils/import/importPayload";
import { IMPORT_BATCH_SIZE, parseFailures, runImportInBatches } from "@utils/import/core/sendBatches";
import { ImportProgress, ImportSummary } from "@utils/import/core/types";

export { IMPORT_BATCH_SIZE };
export type { ImportProgress, ImportSummary };

/**
 * Envia los clientes a la lambda de importacion en lotes secuenciales.
 */
export async function importClients(
    rows: ImportPayloadRow[],
    onProgress?: (progress: ImportProgress) => void
): Promise<ImportSummary> {
    const summary = await runImportInBatches(
        rows,
        async (batch) => {
            const { data, errors } = await ApiClient.mutations.importClientsMutation({
                rows: JSON.stringify(batch.map(toMutationRow)),
            });

            if (errors?.length) {
                throw new ApiError("Error al importar los clientes", "API_ERROR", errors);
            }
            if (!data?.ok) {
                throw new ApiError(data?.error || "No fue posible importar los clientes", "API_ERROR");
            }

            return {
                createdCount: data.createdCount || 0,
                updatedCount: data.updatedCount || 0,
                failures: parseFailures(data.failed),
            };
        },
        onProgress
    );

    // La lambda escribe directo en DynamoDB, asi que la cache local de GenericModelApi
    // (Client esta en CACHEABLE_MODELS) no se entera de los clientes nuevos.
    await ClientApi.invalidateAllByTenant();
    ClientApi.clearCache();

    return summary;
}

const toMutationRow = (row: ImportPayloadRow): { action: string; id?: string; data: Record<string, unknown> } => ({
    action: row.action,
    id: row.id,
    data: row.data,
});
